// Alert Styles

import styled from 'styled-components';
import { media } from 'styles/utils';
import {
  animSlideElastic,
  animSlideElasticRight,
  animSlide,
  animSlideRight,
} from 'styles/animation';

const alertSpacingLeft = '70';
const alertSpacingTop = '62';
const alertSpacing = '30';

export const AlertStyled = styled.div`
  position: fixed;
  width: calc(100% - ${alertSpacing * 2}px);
  line-height: 1.4;
  pointer-events: none;
  z-index: 1004;
  transition: top 0.4s, bottom 0.4s;
  /* Media queries */
  ${media.medium`
    width: 380px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  `}
  a {
    color: inherit;
    opacity: 0.7;
    font-weight: 700;
    &:hover,
    &:focus {
      opacity: 1;
    }
  }

  /* States */
  &.s-alert-show,
  &.s-alert-visible {
    pointer-events: auto;
  }
  &.s-alert-info {
    background-color: #0f2eff;
  }
  &.s-alert-success {
    background-color: #000000;
  }
  &.s-alert-warning {
    background-color: #ffcb00;
  }
  &.s-alert-error {
    background-color: #ff4d00;
  }
  &[class^='s-alert-effect-'].s-alert-hide,
  &[class*=' s-alert-effect-'].s-alert-hide {
    animation-direction: reverse;
  }
  /* Height measurement helper */
  &.s-alert-box-height {
    visibility: hidden;
    position: fixed;
  }
  /* TODO: Review if alert-close is necessary */
  &.s-alert-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 4px;
    top: 4px;
    overflow: hidden;
    text-indent: 100%;
    cursor: pointer;
    backface-visibility: hidden;
    &:hover {
      outline: none;
      &::before,
      &::after {
        background: #fff;
      }
    }
    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 3px;
      height: 60%;
      top: 50%;
      left: 50%;
      background: #fff;
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }

  /*TODO: Review if slert-close inside effect slide is needed */
  &.s-alert-effect-slide .s-alert-close::before,
  &.s-alert-effect-slide .s-alert-close::after {
    background: #fff;
  }
  &.s-alert-effect-slide .s-alert-close:hover::before,
  &.s-alert-effect-slide .s-alert-close:hover::after {
    background: #fff;
  }

  /* Positions */
  &.s-alert-bottom-left {
    top: auto;
    right: auto;
    bottom: ${alertSpacing}px;
    left: ${alertSpacingLeft}px;
  }
  &.s-alert-top-left {
    top: ${alertSpacingTop}px;
    right: auto;
    bottom: auto;
    left: ${alertSpacingLeft}px;
  }
  &.s-alert-top-right {
    top: ${alertSpacingTop}px;
    right: ${alertSpacing}px;
    bottom: auto;
    left: auto;
  }
  &.s-alert-bottom-right {
    /*default*/
    top: auto;
    right: ${alertSpacing}px;
    bottom: ${alertSpacing}px;
    left: auto;
  }
  &.s-alert-bottom,
  &.s-alert-top {
    width: 100%;
    left: 0;
    right: 0;
    border-radius: 0;
  }
  &.s-alert-bottom {
    bottom: 0;
  }
  &.s-alert-top {
    top: 0;
  }

  /* Animations */
  &.s-alert-top-left,
  &.s-alert-bottom-left,
  &.s-alert-top,
  &.s-alert-bottom {
    animation: ${animSlideElastic} 1s linear;
  }

  &.s-alert-top-right,
  &.s-alert-bottom-right {
    animation: ${animSlideElasticRight} 1s linear;
  }

  &.s-alert-top-left.s-alert-hide,
  &.s-alert-bottom-left.s-alert-hide,
  &.s-alert-top.s-alert-hide,
  &.s-alert-bottom.s-alert-hide {
    animation-name: ${animSlide};
    animation-duration: 0.25s;
  }

  &.s-alert-top-right.s-alert-hide,
  &.s-alert-bottom-right.s-alert-hide,
  &.s-alert-top-right.s-alert-hide,
  &.s-alert-bottom-right.s-alert-hide {
    animation-name: ${animSlideRight};
    animation-duration: 0.25s;
  }
`;

export const TextStyled = styled.p`
  font-size: 14px;
  color: #fff;
  padding: 12px;
  /* Media queries */
  ${media.medium`
    font-size: 16px;
    padding: 20px;
  `}
`;
